import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import NetworkImage from 'components/NetworkImage';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import { redirectToExternalUrl } from 'helpers/RouteHelper';
import { getSitePlatform } from 'helpers/BreakpointHelper';
import { PROMO_TYPE_INSET, getPromoData } from '../../SeriesDetailHelpers';
import Style from './HeadlineBumper.module.scss';

function HeadlineBumper({ promos = [] }) {
  const promoData = getPromoData({ data: promos, promoType: PROMO_TYPE_INSET });
  const content = _.get(promoData, 'items.member[0]', {});
  const { ctaText = '', headline = '' } = content;
  const buttonText = ctaText;
  const url = _.get(window.ExternalConfig, 'externalSignUpUrl');
  if (!ctaText || !headline || !url) return <div className={Style.placeholder} />;
  const network = _.get(window.ExternalConfig, 'brand.headerLogo', null);
  const onClick = () => {
    handleAnalytics(
      {
        event: Events.PURCHASE_CTA_CLICKED,
        payload: {
          page_item_title: buttonText,
          page_item_subtitle: '',
          page_action_location:
            getSitePlatform() === 'site-mobile' ? 'mobile sticky' : 'showcase bumper',
          page_button_text: buttonText,
        },
      },
      {
        event: Events.UPGRADE_NOW_BUTTON_CLICKED,
        payload: {
          page_item_title: buttonText,
          page_action_location: 'anonymous series detail',
        },
      },
    );
    if (url) redirectToExternalUrl(url);
  };

  return (
    <section className={Style.container}>
      <div className={Style.innerContainer}>
        <div className={Style.NetworkImageWrap}>
          <NetworkImage network={network} />
        </div>
        <div className={Style.copy}>
          <p>{headline}</p>
        </div>
        <button className={Style.ctaButton} onClick={onClick}>
          {buttonText}
        </button>
      </div>
    </section>
  );
}

HeadlineBumper.propTypes = {
  promos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
export default HeadlineBumper;
